import type { Strings } from './types';

/** 해외판 문안(ADR-047). 앱 이름 'Ajae Snake' 는 자리표시자 — 정식 명칭은 사용자 결정(docs/04 미결). */
export const en: Strings = {
  appName: 'Ajae Snake',
  title: {
    duelTag: 'C H A L L E N G E',
    rules: [
      'Eat the answer letters in order',
      'Know it and go straight; guess and you circle',
      'Time makes you grow; answers make you shrink',
      'Solve all 8 to seal the snake',
    ],
    best: (desc, runs) => `Best ${desc} · ${runs} runs`,
    start: 'Start',
    duelStart: 'Play the same board',
    decline: 'Play my own board',
    hintDuel: 'No question, no answer shown · swipe to steer',
    hintSolo: 'Swipe · arrow keys to steer',
    packLine: (label, inference) => `Pack · ${label}${inference ? ' · hints open one by one' : ''}`,
    switchPack: (label) => `Switch to ${label}`,
  },
  band: { answerLine: (n, marks) => `Answer ${n} letters · ${marks}` },
  hud: {
    line: (sealed, total, len, lenMax, clock, tail) =>
      `Sealed ${sealed}/${total} · Len ${len}/${lenMax} · ${clock} · ${tail}`,
  },
  ledger: {
    line: (total, init, byTime, byAnswer, byWord, byWrong) =>
      `Len ${total} = start ${init} · time ${byTime} · answer ${byAnswer} · word ${byWord} · wrong ${byWrong}`,
  },
  over: {
    sealed: 'Sealed!',
    wall: 'Hit the wall',
    self: 'Trapped',
    engorged: 'Too full',
    unsealed: 'Out of questions',
    end: 'Game over',
    rank: (sealed, total, clock) => `Sealed ${sealed}/${total} · ${clock}`,
    grade: (grade) => `Grade ${grade}`,
    again: 'One more',
    faster: 'Faster',
    share: 'Share result',
    counter: 'Challenge back',
    sameAgain: 'Same board again',
    newRun: 'New board',
    newRecord: (desc) => `New best! ${desc}`,
    best: (desc) => `Best ${desc}`,
    appCta: 'Records · daily · streaks in the app',
    duel: (outcome, opponent) =>
      `${outcome === 'win' ? 'Challenge won' : outcome === 'lose' ? 'Challenge lost' : 'Draw'} · ${opponent}`,
  },
  revive: {
    self: 'Bit your own tail',
    wall: 'Hit the wall',
    sub: 'Answer one to revive',
    alive: 'Revived',
    timeout: 'Time out',
    wrong: 'Wrong',
  },
  intro: [
    'Swipe · arrow keys to move',
    'Your body grows over time',
    'Eating answer letters shrinks it',
  ],
  toast: { wrong: 'Cold…', shared: 'Shared', copied: 'Copied — paste it in chat' },
  note: {
    notSame: 'Not the same board',
    versionOld: 'This challenge is from an older version — records are not compared',
    webTwice: 'On the web you get two tries — starting a new board',
    packUnavailable: 'Could not load the challenge pack — starting a new board',
    devBuild: 'Telemetry off (dev build) — do not measure with this link',
    loading: 'Loading…',
  },
  card: {
    grade: {
      S: 'Pun Master',
      A: 'True Dad',
      B: 'Dad in Training',
      C: 'Aspiring Dad',
      D: 'Joke Apprentice',
      E: 'Sprout',
      F: 'First Step',
    },
    head: (label, grade) => `🐛 Ajae Snake — ${label} (${grade})`,
    headFirst: '🐛 Ajae Snake — first run',
    sealed: (clock) => `Sealed ${clock}`,
    sealedNoTime: 'Sealed',
    solved: (n, total) => `Solved ${n}/${total}`,
    revive: (n) => `Revived ×${n}`,
    nth: (n) => `Run #${n} this session`,
    best: '🏅 Personal best',
    win: 'Challenge won',
    lose: 'Challenge lost',
    draw: 'Draw',
    url: (url) => `▸ Same board: ${url}`,
  },
  opponent: {
    sealed: (clock) => `Rival sealed ${clock}`,
    sealedNoTime: 'Rival sealed',
    solved: (n, total) => `Rival solved ${n}/${total}`,
    rival: 'Rival',
    goal: 'Goal',
  },
  best: {
    sealed: (clock) => `🔒 Sealed ${clock}`,
    alive: (solved, total, clock) => `🐍 ${solved}/${total} · survived ${clock}`,
  },
  ugc: {
    submitBtn: 'Submit a joke',
    topBtn: 'Top jokes',
    submitTitle: 'Submit a joke',
    submitHint:
      'Question 6–40 chars · answer 4–5 capital letters, no repeats · shows up once approved',
    qPlaceholder: 'Which country?',
    aPlaceholder: 'Answer (e.g. SPAIN)',
    send: 'Send',
    sent: 'Sent — it appears once approved',
    myTitle: 'My submissions',
    pending: 'In review',
    approved: 'Approved',
    rejected: 'Declined',
    topTitle: 'Top jokes',
    topNote: 'Answers only in play — star jokes after a run',
    loading: 'Loading…',
    empty: 'No starred jokes yet',
    offline: 'Could not load the list right now',
    playWeekly: 'Play this week’s top pack',
    back: 'Back',
    starTitle: 'Star the jokes from this run',
    unavailable: 'Not taking submissions right now — try again later',
    errOffline: 'No connection — try again in a moment',
    errInvalid: 'That does not fit the format',
    errDuplicate: 'A joke with that answer already exists',
    errLimit: 'Limit reached — 5 in review · 20 per day',
  },
  mute: { on: 'Sound on', off: 'Sound off' },
  rotate: { continue: 'Continue' },
  effects: { bang: 'Bang!', miss: 'So close…' },
  crash: {
    title: 'Oops, something broke',
    body: 'Reloading usually fixes it.',
    reload: 'Try again',
    details: 'Details',
  },
};
